import moment from "moment";
import React, { useEffect, useState } from "react";
import { GridColDef } from "@material-ui/data-grid";
import { useSelector } from "react-redux";

import BaseDataGrid from "../../components/modules/BaseDataGrid";
import Loader from "../../components/elements/Loader";
import PageLayout from "../../layouts/PageLayout";
import SegmentsLogsDashboardToolbar from "./SegmentsLogsToolBar";
import api from "../../api";
import classes from "./SegmentsLogs.module.scss";
import { ReduxApplicationState } from "../../types/ReduxTypes/ReduxApplicationState";

type SegmentLog = {
  subdomain: string;
  originalDomains: string[];
  ipSegment: string;
  date: Date;
};

const SegmentsLogsPage = () => {
  const [segmentsLogs, setSegmentsLogs] = useState<SegmentLog[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const user = useSelector((state: ReduxApplicationState) => state.user);

  useEffect(() => {
    const fetchAndSetSegmentsLogs = async () => {
      try {
        setIsLoading(true);
        const fetchedSegmentsLogs = await api.getSegmentsLogs(user.currentUser);
        setSegmentsLogs(fetchedSegmentsLogs);
        setIsLoading(false);
      } catch (error) {
        console.log(`Error in fetchAndSetSegmentsLogs: ${error}`);
        setIsLoading(false);
      }
    };

    fetchAndSetSegmentsLogs();
  }, [user.currentUser]);

  const columns: GridColDef[] = [
    { field: "date", headerName: "Date", width: 200 },
    { field: "subdomain", headerName: "Subdomain", width: 200 },
    { field: "ipSegment", headerName: "IP Segment", width: 200 },
    { field: "originalDomains", headerName: "Original Domains", width: 700 },
  ];

  const rows = segmentsLogs.map(({ subdomain, originalDomains, ipSegment, date }, index) => ({
    id: `${subdomain}-${index}`,
    date: moment(date).format("MMM Do YYYY, h:mm:ss a"),
    subdomain,
    originalDomains: originalDomains.join(", "),
    ipSegment,
  }));

  return (
    <PageLayout heading="Segments Logs">
      {isLoading ? <Loader /> : null}
      <div className={classes.container}>
        <div className={classes.content}>
          <div className={classes.dashboardContainer}>
            <div className={classes.dashboard}>
              <BaseDataGrid
                columns={columns}
                rows={rows}
                components={{
                  Toolbar: SegmentsLogsDashboardToolbar,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default SegmentsLogsPage;
